import { render, staticRenderFns } from "./sopDetail.vue?vue&type=template&id=e414e546"
import script from "./sopDetail.vue?vue&type=script&lang=js"
export * from "./sopDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e414e546')) {
      api.createRecord('e414e546', component.options)
    } else {
      api.reload('e414e546', component.options)
    }
    module.hot.accept("./sopDetail.vue?vue&type=template&id=e414e546", function () {
      api.rerender('e414e546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/sopDetail.vue"
export default component.exports